import { render, staticRenderFns } from "./EditDataImport.vue?vue&type=template&id=685f2b08&scoped=true&"
import script from "./EditDataImport.vue?vue&type=script&lang=js&"
export * from "./EditDataImport.vue?vue&type=script&lang=js&"
import style0 from "./EditDataImport.vue?vue&type=style&index=0&id=685f2b08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685f2b08",
  null
  
)

export default component.exports